(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('profileOffice365EmailsUserUserEmails', ["path", "userDao", function (path, userDao) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('profile/office365_emails_user/user-emails').template('user-emails'),
            scope: { shared: '=?profileOffice365EmailsUserUserEmails' },
            link: function ($scope, element, attrs) {
                $scope.model = [];
                $scope.loadData = function () {
                    return userDao.userEmailAddressesSimple($scope.shared.id).order('entity_id', 'asc').then(function (response) {
                        $scope.model = _(response.data.rows).pluck('entity_id');
                    });
                };
            }
        };
    }]);
}());